import { styled } from '@uhg-abyss/web/tools/styled';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Text } from '@uhg-abyss/web/ui/Text';

import { desktopOnly, mobileOnly, notMobile } from '../../ConstantsStyles';

export const AttributeLabel = styled(Text, {
  '&.abyss-text-root': {
    paddingBottom: '$sm',
  },
});

export const AttributeValue = styled(Text, {
  '&.abyss-text-root': {
    paddingLeft: '$xs',
  },
});

export const ComparisonGridContainer = styled('div', {
  display: 'grid',
  gridTemplateColumns: '1fr',
  height: '508px',
  overflowY: 'auto',
  [`@media ${notMobile}`]: {
    height: '542px',
    gridTemplateColumns: '1fr 1fr',
  },
  [`@media ${desktopOnly}`]: {
    height: '542px',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
  },
});

export const ProviderCard = styled(Card, {
  '&.abyss-card-root': {
    fontFamily: '$primary',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    // below tablet: top/left/right $md, bottom 32px
    padding: `$md $md 32px $md`,
    border: 'none',
    marginTop: '0px',
    boxShadow: 'none',
    borderRadius: '0px',
    [`@media ${notMobile}`]: {
      // tablet up to desktop: $md on all sides
      padding: '$md',
    },
    [`@media ${desktopOnly}`]: {
      // desktop and up: $md top/bottom, $sm left/right
      padding: `$md $sm`,
    },
  },
  variants: {
    variant: {
      white: {
        '&.abyss-card-root': {
          backgroundColor: 'white',
        },
      },
      gray: {
        '&.abyss-card-root': {
          backgroundColor: '$core.color.neutral.10',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'white',
  },
});

export const providerCardTitle = {
  'abyss-text-root': {
    color: '$primary1',
    marginBottom: '$md',
    [`@media ${desktopOnly}`]: {
      display: '-webkit-box',
      marginBottom: '$xs',
      // Desktop only: reserve 2 lines (2 x 24px) so 1- and 2-line titles stay aligned.
      height: '48px',
    },
  },
};

export const ctaButtonStyles = {
  'abyss-button-root': {
    width: '100%',
    borderRadius: '24px',
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '24px',
    marginTop: '32px',
    [`@media ${desktopOnly}`]: {
      marginTop: 'auto',
      fontSize: '14px',
      lineHeight: '18px',
    },
  },
  'abyss-button-content-container': {
    height: '32px',
    [`@media ${mobileOnly}`]: {
      height: '44px',
    },
  },
};

export const descriptionTextCss = {
  'abyss-text-root': {
    paddingBottom: '$md',
  },
};

export const ProviderAttributeContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: '$md',
});

export const costIndicatorCss = {
  paddingLeft: '$xs',
  paddingRight: '$xs',
};
